// AdminZoneController.js
angular.module('tf.controllers')
    .controller('AdminZoneController', ['$scope', 'HttpService','HeaderService', function($scope, HttpService,HeaderService) {
        HeaderService.setName("Admin Zone");
        $scope.showEditModal = false;
        $scope.selectedFarm = null;
        $scope.farms = [];
        $scope.loading = {
            farms: true,
            save: false,
            imageApi: {}
        };
        $scope.errors = {
            fetch: false,
            save: false
        };

        HttpService.get('super-admin/farms')
            .then(function(response) {
                if (response.data.farms) {
                    $scope.farms = response.data.farms;
                } else {
                    $scope.errors.fetch = true;
                }
            })
            .catch(function(error) {
                $scope.errors.fetch = true;
                console.error('Error fetching farms:', error);
            })
            .finally(function() {
                $scope.loading.farms = false;
            });

        $scope.saveFarmSettings = function() {
            $scope.loading.save = true;
            $scope.errors.save = false;
            
            HttpService.post('super-admin/update-farm-settings', $scope.selectedFarm)
                .then(function(response) {
                    if (response.data.success) {
                        let index = $scope.farms.findIndex(f => f._id === $scope.selectedFarm._id);
                        if (index !== -1) {
                            $scope.farms[index] = angular.copy($scope.selectedFarm);
                        }
                        $scope.showEditModal = false;
                    } else {
                        $scope.errors.save = true;
                    }
                })
                .catch(function(error) {
                    $scope.errors.save = true;
                    console.error('Error saving farm settings:', error);
                })
                .finally(function() {
                    $scope.loading.save = false;
                });
        };

        $scope.editFarm = function(farm) {
            $scope.selectedFarm = angular.copy(farm);
            $scope.showEditModal = true;
        };

        $scope.cancelEdit = function() {
            $scope.showEditModal = false;
            $scope.selectedFarm = null;
        };

        $scope.updateImageApiStatus = function(farm) {
            $scope.loading.imageApi[farm._id] = true;
            const previousState = farm.plan.image_api;
            
            HttpService.post('super-admin/update-image-api', {
                _id: farm._id,
                image_api: farm.plan.image_api
            })
            .then(function(response) {
                if (!response.data.success) {
                    farm.plan.image_api = previousState;
                }
            })
            .catch(function(error) {
                farm.plan.image_api = previousState;
                console.error('Error updating Image API status:', error);
            })
            .finally(function() {
                $scope.loading.imageApi[farm._id] = false;
            });
        };
    }]);


